/* eslint-disable max-len */
/* eslint-disable security/detect-object-injection */

import moment from 'moment';
import React, { useContext, useState } from 'react';
import AnimatedList from '../../../../../components/Animation/AnimatedList';
import { useNavigate, useSearchParams } from 'react-router-dom';
import GlobalContext from '../../../../../components/Context/GloablContext';

const TableBody = ({tableData, indexNum, isRole }) => {

    const location=useNavigate();
    const {setToastmessage, isInactiveBranch}=useContext(GlobalContext)
    const [searchParams, setSearchParams] = useSearchParams('')

    /* The code snippet you provided is defining a function `handleEditClick` that is responsible for
    handling the click event on a button. Here's a breakdown of what the code is doing: */
    const handleEditClick = () => {
        if (tableData?.status === 'completed') {
            setToastmessage("This AY is marked as completed. No further changes are allowed.");
        } else {
            location(`/manage-academic-years/edit/${tableData?._id}?${searchParams.toString()}`);
        }

    };

    /**
     * The `handleStatus` function takes a key as input and returns the corresponding value based on the
     * status provided in the table data.
     * @returns The function `handleStatus` is returning the value of the specified key from the object
     * `val` based on the status provided in the `tableData`.
     */
    const handleStatus = (key) => {
        let val = {}
        switch (tableData?.status) {
        case "ongoing":
            val = {status : "Ongoing", img: "successDot.svg", color : "bg-[#C5FFD5]"}
            break;
        case "draft":
            val = {status : "Draft", img: "draft-img.svg", color : "bg-[#FFEEB0]"}
            break;
        case "completed":
            val = {status :"Completed", img: "Completed_dot.svg", color : "bg-[#C2DCEF]"}
            break;
        case "upcoming":
            val = {status : "Upcoming", img: "upcoming_dot.svg", color : "bg-[#FAC39B]"}
            break;
        
        default:
            break;
        }
        return val[key]
    }

    return (
        <>
            
            <AnimatedList
                rowStatus={tableData.status}
                keyItem={indexNum}
                child={
                    <>
                        <td class="text-start">
                            {tableData?.name}
                        </td>
                        <td class="text-start">{moment(tableData?.start_date).utcOffset('+00:00').format('MMM DD, YYYY')}</td>
                        <td class="text-start">{moment(tableData?.end_date).utcOffset('+00:00').format('MMM DD, YYYY')}</td>
                        <td class="table-cell">
                            <div className='flex justify-start'>
                                <div class={`w-fit rounded ${handleStatus("color")} flex items-center justify-start py-1 px-2.5`}>
                                    <img loading="lazy" decoding="async" src={`images/${handleStatus("img")}`} alt="icon"/>
                                    <span class="text-f7 font-normal text-[#031624] pl-2.5">{handleStatus("status")} </span>
                                </div>
                            </div>
                        </td>
                        {!isRole && <td class="text-center">
                            <button type="button"  id = "edit" class='list-actn-btn'
                                onClick={handleEditClick}
                                disabled={(tableData.status===''?true:false) || isInactiveBranch || (tableData?.status === 'completed')}>
                                Change Status
                            </button>
                        </td>}
                    </>
                }/>
        </>
    );
}

export default TableBody;
